import { TViewSubcategoryAction, ViewSubcategoryActionTypes } from './viewSubcategoryActions';
import { IViewSubcategoryState } from './viewSubcategoryContext';

export const viewSubcategoryReducer = (
	state: IViewSubcategoryState,
	action: TViewSubcategoryAction,
): IViewSubcategoryState => {
	switch (action.type) {
		case ViewSubcategoryActionTypes.REFETCH_DATA:
			return {
				...state,
				needRefetchData: action.payload.needRefetchData,
			};
		case ViewSubcategoryActionTypes.REFETCH_REST_PROPS_DATA:
			return {
				...state,
				needRefetchRestPropsData: action.payload.needRefetchRestPropsData,
			};
		case ViewSubcategoryActionTypes.SET_SUBCATEGORY_FULL_INFO:
			return {
				...state,
				subcategoryFullInfo: action.payload.subcategoryFullInfo,
				accessibleRestaurants: action.payload.accessibleRestaurants,
			};
		case ViewSubcategoryActionTypes.SET_RESTAURANT_ID_FOR_RESTAURANT_PROPS:
			return {
				...state,
				restaurantIdForRestaurantProps: action.payload.restaurantIdForRestaurantProps,
				restaurantProps: action.payload.restaurantProps,
			};
		case ViewSubcategoryActionTypes.SET_RESTAURANT_PROPS:
			return {
				...state,
				restaurantProps: action.payload.restaurantProps,
			};
		case ViewSubcategoryActionTypes.SET_TRANSLATION_TAB:
			return {
				...state,
				selectedTranslationTab: action.payload.selectedTranslationTab,
			};
		case ViewSubcategoryActionTypes.CHANGE_TYPE_OF_MODAL_WINDOW:
			return {
				...state,
				typeOfModalWindow: action.payload.typeOfModalWindow,
			};
		default:
			return state;
	}
};
